var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolume = function SvgVolume(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.5 7.067 10.515 12.5H5.5v7h5.015l6.985 5.433zM9.485 9.5l8.594-6.684L20.5 4v24l-2.42 1.184L9.484 22.5H2.5v-13zM30 9.5v13h-3v-13zm-4.5 2v9h-3v-9z",
    clipRule: "evenodd"
  })));
};
export default SvgVolume;